export default __webpack_public_path__ + "static/media/Group449@2x.8259b039.png";